import React from 'react';
import { NpsCampaignDto } from '@area-restrita/api-client/model/npsCampaignDto';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import NpsCampaignCommentsDialog from '@/modules/nps/components/NpsCampaignCommentsDialog';
import NpsCampaignResultsDialog from '@/modules/nps/components/NpsCampaignResultsDialog';
import { getNpsResultsEligibility } from '@/modules/nps/utils';

import NpsCampaignExportButton from '../Campaigns/NpsCampaignExportButton';

interface IProps {
  campaign: NpsCampaignDto;
}

const CompanyNpsCampaignActionsCell: React.FC<IProps> = ({ campaign }) => {
  const { checkAuthorization } = useAuthSessionStore();
  const canViewDetails = checkAuthorization(({ can }) =>
    can('viewDetails', 'nps'),
  );
  const canViewComments = checkAuthorization(({ can }) =>
    can('viewComments', 'nps'),
  );
  const canExport = checkAuthorization(({ can }) => can('export', 'nps'));
  const resultsEligibility = getNpsResultsEligibility({
    campaign,
    canViewDetails,
    userType: 'company',
  });
  const commentsEnabled = canViewComments && campaign.commentsVisibleToCompany;
  const commentsDisabledReason = !canViewComments
    ? 'Seu perfil não possui permissão para visualizar comentários NPS.'
    : 'Os comentários desta campanha não foram liberados para a empresa.';

  return (
    <div className="flex justify-end gap-2">
      <NpsCampaignResultsDialog
        campaign={campaign}
        disabled={!resultsEligibility.enabled}
        disabledReason={resultsEligibility.disabledReason}
        showComments={false}
      />

      <NpsCampaignCommentsDialog
        campaign={campaign}
        disabled={!commentsEnabled}
        disabledReason={commentsDisabledReason}
      />

      <NpsCampaignExportButton
        campaign={campaign}
        canExport={canExport}
        canViewComments={canViewComments}
        userType="company"
      />
    </div>
  );
};

export default CompanyNpsCampaignActionsCell;
